var exports = {
  "J": "ProfileCardContent.module__contentSection___TlliWF",
  "s": "ProfileCardContent.module__contentSectionWebhook___TlliWF",
};

module.exports = exports;
